export default __webpack_public_path__ + "static/media/TheXPsniper.282a44f2.png";